import { render, staticRenderFns } from "./AdminSelect.vue?vue&type=template&id=8dc256ea&scoped=true"
import script from "./AdminSelect.vue?vue&type=script&lang=js"
export * from "./AdminSelect.vue?vue&type=script&lang=js"
import style0 from "./AdminSelect.vue?vue&type=style&index=0&id=8dc256ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc256ea",
  null
  
)

export default component.exports